import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import HoldList from "./HoldList";
import HoldForm from "./HoldForm";
import BookingRequestForm from "./BookingRequestForm";
import HoldDetails from "./HoldDetails";

/**
 * BookingsPage - Main routing component for Hold & Challenge System
 *
 * Routes:
 * - / → HoldList (list all holds)
 * - /new → HoldForm (create new hold)
 * - /:id → HoldDetails (view hold details)
 * - /:id/edit → HoldForm (edit hold)
 */
const BookingsPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<HoldList />} />
      <Route path="/" element={<HoldList />} />
      <Route path="/request" element={<BookingRequestForm />} />
      <Route path="/new" element={<HoldForm />} />
      <Route path="/:id" element={<HoldDetails />} />
      <Route path="/:id/edit" element={<HoldForm />} />
      <Route path="*" element={<Navigate to="/bookings" replace />} />
    </Routes>
  );
};

export default BookingsPage;
